(() => {
  const ROOT_SELECTOR = "[data-aulumu-root]";

  class AulumuCollection {
    constructor(root) {
      this.root = root;
      this.nav = root.querySelector("[data-aulumu-nav]");
      this.navLinks = Array.from(root.querySelectorAll("[data-aulumu-nav-link]"));
      this.filterButtons = Array.from(root.querySelectorAll("[data-aulumu-filter]"));
      this.filterCards = Array.from(
        root.querySelectorAll("[data-aulumu-filter-grid] [data-aulumu-card]")
      );
      this.jumpLinks = Array.from(root.querySelectorAll("[data-aulumu-filter-jump]"));
      this.observedSections = Array.from(root.querySelectorAll("[data-aulumu-observe]"));
      this.activeFilter = "all";

      this.bindSmoothAnchors();
      this.bindFilters();
      this.bindFilterJumps();
      this.observeSections();
    }

    getOffset() {
      const navHeight = this.nav ? this.nav.getBoundingClientRect().height : 0;
      const cssOffset = Number.parseFloat(
        getComputedStyle(this.root).getPropertyValue("--aulumu-nav-offset")
      );

      return navHeight + (Number.isFinite(cssOffset) ? cssOffset : 0) + 12;
    }

    scrollToElement(target) {
      if (!target) return;

      const top = target.getBoundingClientRect().top + window.scrollY - this.getOffset();

      window.scrollTo({
        top: Math.max(0, top),
        behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches
          ? "auto"
          : "smooth",
      });
    }

    bindSmoothAnchors() {
      const links = Array.from(this.root.querySelectorAll('a[href^="#aulumu-"]'));

      links.forEach((link) => {
        link.addEventListener("click", (event) => {
          const selector = link.getAttribute("href");
          const target = selector ? document.querySelector(selector) : null;

          if (!target) return;

          event.preventDefault();
          this.scrollToElement(target);
        });
      });
    }

    applyFilter(category) {
      this.activeFilter = category;

      this.filterButtons.forEach((button) => {
        const isActive = button.dataset.aulumuFilter === category;
        button.classList.toggle("is-active", isActive);
        button.setAttribute("aria-pressed", isActive ? "true" : "false");
      });

      this.filterCards.forEach((card) => {
        const cardCategory = card.dataset.aulumuCategory;
        card.hidden = category !== "all" && cardCategory !== category;
      });
    }

    bindFilters() {
      this.filterButtons.forEach((button) => {
        button.setAttribute(
          "aria-pressed",
          button.classList.contains("is-active") ? "true" : "false"
        );

        button.addEventListener("click", () => {
          this.applyFilter(button.dataset.aulumuFilter || "all");
        });
      });
    }

    bindFilterJumps() {
      this.jumpLinks.forEach((link) => {
        link.addEventListener("click", () => {
          this.applyFilter(link.dataset.aulumuFilterJump || "all");
        });
      });
    }

    setActiveNav(category) {
      this.navLinks.forEach((link) => {
        const isActive = link.dataset.aulumuNavLink === category;
        link.classList.toggle("is-active", isActive);

        if (isActive) {
          link.setAttribute("aria-current", "true");
        } else {
          link.removeAttribute("aria-current");
        }
      });
    }

    observeSections() {
      if (!("IntersectionObserver" in window) || !this.observedSections.length) return;

      const observer = new IntersectionObserver(
        (entries) => {
          const visible = entries
            .filter((entry) => entry.isIntersecting)
            .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];

          if (visible) {
            this.setActiveNav(visible.target.dataset.aulumuObserve);
          }
        },
        {
          rootMargin: "-28% 0px -58% 0px",
          threshold: [0.01, 0.15, 0.35],
        }
      );

      this.observedSections.forEach((section) => observer.observe(section));
    }
  }

  const initialize = (scope = document) => {
    scope.querySelectorAll(ROOT_SELECTOR).forEach((root) => {
      if (root.dataset.aulumuInitialized === "true") return;
      root.dataset.aulumuInitialized = "true";
      new AulumuCollection(root);
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initialize());
  } else {
    initialize();
  }

  document.addEventListener("shopify:section:load", (event) => initialize(event.target));
})();

